// extracted by mini-css-extract-plugin
export default {"main":"formacontact_main__kAcCs","userBox":"formacontact_userBox__g1tmV","text":"formacontact_text__qsJHI","box":"formacontact_box__ZOexQ","boxname":"formacontact_boxname__i+jpL"};